// src/api/team_view_api.js
import { API_BASE } from "./common_api";


// ================= USER =================
export async function fetchUser(email) {
  const r = await fetch(`${API_BASE}/dashboard/employee?email=${email}`);
  return await r.json();
}

// ================= MANAGERS =================
export async function fetchManagers(email) {
  const r = await fetch(`${API_BASE}/dashboard/team_members?email=${email}`);
  return await r.json();
}

export async function fetchTeamOfManager(email, managerEmail) {
  const r = await fetch(
    `${API_BASE}/dashboard/team_members?email=${email}&manager_email=${managerEmail}`
  );
  return await r.json();
}

export async function fetchManagerTeam(email) {
  const r = await fetch(`${API_BASE}/dashboard/manager_team?email=${email}`);
  return await r.json();
}

// ================= REFLECTION =================
export async function fetchReflection(empEmail, period) {
  let r = await fetch(
    `${API_BASE}/reflection/hierarchy_view?email=${empEmail}&period=${period}`
  );
  let d = await r.json();

  if (!r.ok) {
    r = await fetch(
      `${API_BASE}/reflection/view?email=${empEmail}&period=${period}`
    );
    d = await r.json();
  }

  return d;
}

// ================= TIMESHEET =================
export async function fetchTimesheet(params) {
  const r = await fetch(
    `${API_BASE}/timesheet/team_hierarchy?${params.toString()}`
  );
  return await r.json();
}

// ================= SKILLS =================
export async function fetchSkillsAPI(email, skillsPeriod, skillsDate, empEmail) {
  const params = new URLSearchParams();
  params.append("email", email);
  params.append("period", skillsPeriod);
  params.append("date_value", skillsDate);
  params.append("target_email", empEmail);

  const r = await fetch(`${API_BASE}/reflection/team_skills?${params}`);
  return await r.json();
}

// ================= MISSING =================
export async function fetchMissingReflection(email, period, date) {
  const params = new URLSearchParams();
  params.append("email", email);
  params.append("period", period);
  params.append("date_value", date);

  const r = await fetch(`${API_BASE}/reflection/missing?${params}`);
  return await r.json();
}

export async function fetchMissingTimesheet(email, date) {
  const params = new URLSearchParams();
  params.append("email", email);
  params.append("date", date);

  const r = await fetch(`${API_BASE}/timesheet/missing?${params}`);
  return await r.json();
}